import { User } from "../types/user";

export const UserMock: User = {
  uN: "usermcusernameface",
  email: "user@user.user",
  token: "123245",
  ia: true,
};
